// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
/**
 * Builds the dropdown `header` and `footer` nodes shared by Select and Multiselect. When no custom header or
 * custom footer is provided, the header is just the filter and the footer is the built-in sticky status, so the
 * output is identical to the component's original behavior.
 */
export function composeDropdownContent({ filter, customDropdownHeader, customDropdownFooter, statusFooter, dropdownHeaderClass, dropdownFooterClass, }) {
    const headerNode = customDropdownHeader !== null && customDropdownHeader !== void 0 ? customDropdownHeader : null;
    const footerNode = customDropdownFooter !== null && customDropdownFooter !== void 0 ? customDropdownFooter : null;
    // Custom header renders at the top of the dropdown, above the filter (and options list).
    const header = headerNode !== null ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: dropdownHeaderClass }, headerNode),
        filter)) : (filter);
    // Only wrap the footer in a fragment when a custom footer is present; otherwise keep the original sticky-status node.
    const footer = footerNode !== null ? (React.createElement(React.Fragment, null,
        statusFooter,
        React.createElement("div", { className: dropdownFooterClass }, footerNode))) : (statusFooter);
    return { header, footer };
}
//# sourceMappingURL=dropdown-customization.js.map